import { properties } from "./Defs";
import * as msc from "mascot-vis";
import store from "./store";
import { updateRedoStack, updateUndoStack } from "./canvasSlice";

const addToStack = (scene, datasets, stack, type) => {
    let stackType = type ? type : "undo";
    let scn = scene.toJSON();
    for (let t of datasets) {
        if (!(t.id in scn.tables)) {
            scn.tables[t.id] = t.toJSON();
        }
    }
    // let s = stack.slice();
    // s.push(JSON.stringify(scn));
    // setStack(s);
    stack.push(JSON.stringify(scn));
    // console.log("added to stack", stackType, stack.length);
    if (stackType === "undo")
        store.dispatch(updateUndoStack({"length": stack.length}));
    else if (stackType === "redo")
        store.dispatch(updateRedoStack({"length": stack.length}));
}

const getSVGPathData = (items, vxSize) => {
    let d = "";
    for (let i of items) {
        if (i.getSVGPathData)
            d += i.getSVGPathData();
        else if (i.bounds) {
            let b = i.bounds;
            d += ["M", b.left, b.top].join(" ");
            d += ["L", b.right, b.top].join(" ");
            d += ["L", b.right, b.bottom].join(" ");
            d += ["L", b.left, b.bottom, "Z"].join(" ");
        } else if (i.type === "vertex") {
            let size = Math.max(i.width, i.height, i.radius, vxSize);
            d += ["M", i.x - size/2, i.y - size/2].join(" ");
            d += ["L", i.x + size/2, i.y - size/2].join(" ");
            d += ["L", i.x + size/2, i.y + size/2].join(" ");
            d += ["L", i.x - size/2, i.y + size/2, "Z"].join(" ");
        }
    }
    return d;
}

// const getPathVerticesData = (p, vertexSize) => {
//     let d = "";
//     for (let v of p.vertices) {
//         let size = Math.max(v.width, v.height, v.radius, vertexSize);
//         d += ["M", v.x - size/2, v.y - size/2].join(" ");
//         d += ["L", v.x + size/2, v.y - size/2].join(" ");
//         d += ["L", v.x + size/2, v.y + size/2].join(" ");
//         d += ["L", v.x - size/2, v.y + size/2, "Z"].join(" ");
//     }
//     return d;
// }

const getReusableScales = (fieldType, channel, scene) => {
    let r = {};
    for (let itmKey in scene.encodings) {
        let encs = scene.encodings[itmKey];
        for (let c in encs) {
            let enc = encs[c];
            if (canShareScale(c, channel) && enc.dataTable.getFieldType(enc.field) === fieldType) {
                if (!(enc.scale.id in r))
                    r[enc.scale.id] = [];
                r[enc.scale.id].push(enc);
            }   
        }
    }
    return r;
}

const getAggregator = (channel, selected, directSelected, scene) => {
    if (!channel) return null;
    let item;
    if (selected.length >= 1) {
        item = scene.getItem(selected[0]);
    } else if (directSelected) {
        item = scene.getItem(directSelected);
    }
    if (!item) return null;
    //if (!item.dataScope) return null;
    //if (item.dataScope.numTuples === 1) return null; 
    let enc = scene.getEncodingByItem(item, channel);
    if (!enc) return null;
    return enc.aggregator;
}

const getScheme = (channel, selected, directSelected, scene) => {
    let item;
    if (selected.length >= 1) {
        item = scene.getItem(selected[0]);
    } else if (directSelected) {
        item = scene.getItem(directSelected);
    }
    if (!item) return null; 
    let enc = scene.getEncodingByItem(item, channel);
    if (!enc) return null;
    return enc.scale.scheme;
}

const getScaleType = (channel, selected, directSelected, scene) => {
    let item;
    if (selected.length >= 1) {
        item = scene.getItem(selected[0]);
    } else if (directSelected) {
        item = scene.getItem(directSelected);
    }
    if (!item) return null;
    let enc = scene.getEncodingByItem(item, channel);
    if (!enc) return null;
    return enc.scale.type;
}

const canShareScale = (channel1, channel2) => {
    const candidates = [["x", "width"], ["y", "height"], ["fillColor", "strokeColor"]];
    for (let c of candidates) {
        if (c.indexOf(channel1) >= 0 && c.indexOf(channel2) >= 0) {
            return true;
        }
    }
    return false;
}

const getDefaultCollectionLayout = (item, numItems) => {
    let ar = item.bounds.width/item.bounds.height,
        doubleGap = item.type === "collection" && item.layout && item.layout.type === "grid",
        rowGap = doubleGap ? item.layout.rowGap * 3 : 5,
        colGap = doubleGap ? item.layout.colGap * 3 : 5;
    // if (numItems > 50) {
    //     return msc.layout("grid", {"numRows": Math.floor(Math.sqrt(numItems)), "rowGap": rowGap, "colGap": colGap});
    // } else {
    if (ar > 2) {
        return msc.layout("grid", {"numCols": 1, "rowGap": rowGap});
    } else {
        return msc.layout("grid", {"numRows": 1, "colGap": colGap});
    }
    //}
}

const getPositionInScene = (clientX, clientY) => {
    // const rect = document.getElementById("canvas").getBoundingClientRect();
    // return [clientX - rect.x, clientY - rect.y];
    const svg = document.getElementById('canvas');
    const pt = svg.createSVGPoint();
    pt.x = clientX;
    pt.y = clientY;
    const svgP = pt.matrixTransform(svg.getScreenCTM().inverse());
    return [svgP.x, svgP.y];
}

const getPositionInWindow = (sceneX, sceneY) => {
    const rect = document.getElementById("canvas").getBoundingClientRect();
    return [sceneX + rect.x, rect.y + sceneY];
}

const getDefaultLayout = (layout) => {
    switch (layout) {
        case "stack":
            return msc.layout("stack", {orientation: "vertical"});
        case "packing":
            return msc.layout("packing");
        case "none":
            return undefined;
        case "grid":
        default:
            return msc.layout("grid", {numRows: 1});
    }
}

const getPropertyID = (itemType, prop) => {
    switch (itemType) {
        case "vertex":
            return "vx" + prop.replace(/^\w/, c => c.toUpperCase());;
        case "scene":
            return "canvas" + prop.replace(/^\w/, c => c.toUpperCase());;
        case "collection": 
        case "segment":
        case "legend":
            return itemType + prop.replace(/^\w/, c => c.toUpperCase());
        default:
            return prop;
    }
}

const getPropertyDef = (itemType, prop) => {
    const id = getPropertyID(itemType, prop);
    for (let g in properties) {
        for (let p in properties[g]) {
            if (properties[g][p].id === id)
                return properties[g][p];
        }
    }
    return null;
}

export {addToStack, getSVGPathData, getDefaultLayout, getScaleType, getAggregator, getScheme, getReusableScales, getPositionInScene, getPositionInWindow, getPropertyID, getPropertyDef, getDefaultCollectionLayout};